import {
  formatNumberWithUnit,
  formatPercentageNumber,
} from '@terminal/widgets/earnings/utils/utils';

interface FormatNumberOptions {
  isPercentage: boolean;
  value?: number;
  addPlus?: boolean;
}

export const formatNumber = ({
  isPercentage,
  value,
  addPlus,
}: FormatNumberOptions) => {
  if (isPercentage) {
    return formatPercentageNumber({ value, includePercentSign: true, addPlus });
  }

  return formatNumberWithUnit(value);
};
